var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 62,
    viewBox: "0 0 54 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_66_585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8713 8.14936C37.9027 4.18079 32.6241 2 27.0142 2C21.3965 2 16.1256 4.18079 12.1571 8.14936C8.18849 12.1179 6 17.3965 6 23.0065C6 34.3573 16.7344 43.8049 22.5062 48.8754C23.3076 49.5843 23.9934 50.1931 24.5483 50.7017C25.2418 51.349 26.128 51.6727 27.0142 51.6727C27.9004 51.6727 28.7865 51.349 29.4724 50.7017C30.0272 50.1931 30.7207 49.5843 31.5222 48.8754C37.2862 43.8049 48.0206 34.3573 48.0206 23.0065C48.0206 17.3965 45.8398 12.1179 41.8713 8.14936Z",
    fill: "#50AC58",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0857 23.1047C18.9634 23.1047 19.7503 22.7914 20.3126 22.2988C20.8749 22.7931 21.6643 23.1047 22.5429 23.1047C23.4223 23.1047 24.2126 22.7914 24.7749 22.3039C25.3371 22.7948 26.124 23.1047 27 23.1047C27.8751 23.1047 28.6629 22.7948 29.2243 22.2963C29.7874 22.7914 30.5769 23.1047 31.4571 23.1047C32.3357 23.1047 33.1243 22.7923 33.6874 22.2988C34.2497 22.7923 35.0366 23.1047 35.9143 23.1047C37.6149 23.1047 39 21.9477 39 20.5263C39 20.4379 38.9854 20.3486 38.9571 20.2644L36.7286 13.5802C36.6129 13.2341 36.2846 13 35.9143 13H18.0857C17.7154 13 17.3863 13.2341 17.2714 13.5802L15.0429 20.2644C15.0146 20.3486 15 20.437 15 20.5263C15 21.9477 16.3843 23.1047 18.0857 23.1047ZM38.1429 32.3159H36.7714V23.8617C36.4971 23.9206 36.2057 23.9459 35.9143 23.9459C35.0914 23.9459 34.3286 23.7185 33.6943 23.3396C33.0514 23.7185 32.2886 23.9459 31.4571 23.9459C30.78 23.9459 30.1371 23.7943 29.5714 23.5248V26.0005H31.2343C31.7057 26.0005 32.0914 26.3794 32.0914 26.8425C32.0914 27.3057 31.7057 27.6846 31.2343 27.6846H29.5714V32.3159H27.8571V23.8617C27.5829 23.9206 27.3 23.9459 27 23.9459C26.1686 23.9459 25.4057 23.7185 24.7714 23.3396C24.1371 23.7185 23.3657 23.9459 22.5429 23.9459C21.7114 23.9459 20.9486 23.7185 20.3057 23.3396C19.6714 23.7185 18.9086 23.9459 18.0857 23.9459C17.7943 23.9459 17.5029 23.9206 17.2286 23.8617V32.3159H15.8571C15.384 32.3159 15 32.6923 15 33.1579C15 33.6236 15.384 34 15.8571 34H38.1429C38.6169 34 39 33.6236 39 33.1579C39 32.6923 38.6169 32.3159 38.1429 32.3159ZM25.98 25.2005C26.2114 25.4279 26.28 25.7563 26.1943 26.0342C26.1514 26.1689 26.0829 26.2868 25.98 26.3962L22.9457 29.3687C22.7743 29.5371 22.56 29.6213 22.3371 29.6213C22.1229 29.6213 21.9 29.5371 21.7371 29.3687C21.3943 29.0403 21.3943 28.5098 21.7371 28.1814L24.7629 25.2005C25.0971 24.8721 25.6371 24.8721 25.98 25.2005ZM20.82 25.5037L22.0371 24.308C22.3714 23.9796 22.9114 23.9796 23.2457 24.308C23.58 24.6364 23.58 25.1753 23.2457 25.5037L22.0371 26.691C21.8657 26.8594 21.6514 26.9352 21.4286 26.9352C21.2143 26.9352 20.9914 26.8594 20.82 26.691C20.4857 26.3626 20.4857 25.8321 20.82 25.5037Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_66_585",
    x: 0.5,
    y: 0.5,
    width: 53.0205,
    height: 60.6727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_66_585"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_66_585",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenStore);
export default __webpack_public_path__ + "static/media/greenStore.20f803281ad2ef7372fa0b1516c499e2.svg";
export { ForwardRef as ReactComponent };